<template>
  <img src="@/assets/images/logos/zqai.webp"/>
</template>
<script setup>
</script>